import { useState } from "react";
import { H3, Label } from "../Text";
import { toast } from "react-toastify";
import Circle from "../Animation/Circle";
import { Button } from "../Buttons";
import { Request } from "../../hooks/Request";
import TableComplete from "../Tables/TableComplete";
import { requestAuth } from "../services/RequestService";
import { useDialog } from "../../contexts/DialogContext";
import { DialogConfirmation } from "../Modal";
import CreatableSelect from "react-select/creatable";
import { validateArray } from "../../utils/validate";

const InputSubDocumentToDeliver = ({ field }) => {
  const { openDialog, dialogClose } = useDialog();

  const { data, loading, call } = Request({
    urlApi: `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
  });

  const { data: document, loading: loadDocument, call: callDocument } = Request({ urlApi: field.urlApi });

  const descriptionOptions = [
    { name: "Conciliacion de deposito bancario" },
    { name: "Nota de Cobranza de despacho Aduanero" },
    { name: "Recibo Único de Pago" },
    { name: "DIM Original" },
    { name: "Factura Agencia" },
    { name: "Recibo de Pago al Banco" },
    { name: "Planilla de despacho Aduanero" },
    { name: "Factura de Almacenaje" },
    { name: "DIM Original para Comercial" },
    { name: "DIM Original para Tramite de Alcaldia" },
    { name: "DIM Original para Tramite en Transito" },
  ];

  function handleForm(item) {
    openDialog(
      <>
        {loadDocument && (
          <div className="min-h-[360px]">
            <FormAddDocument
              data={descriptionOptions}
              item={item}
              reload={call}
              field={field}
              onClose={dialogClose}
              callDocument={callDocument}
            />
          </div>
        )}
      </>
    );
  }

  function handleDelete(data) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar este item?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/dataSet/procedure/subData/${data.id}`}
        texBtn="Eliminar"
        handleSuccess={call}
      />
    );
  }
  console.log("Datos de Entrega de Documento: ", data)

  return (
    <div className="bg-gray-300/40 p-2 rounded-md">
      <Label htmlFor={field.name} className={`${field.className} my-0`}>
        {field.labelCustom ? field.labelCustom : field.label}
      </Label>
      <div className="bg-gray-100 rounded-lg p-3 pt-2">
        {loadDocument && (
          <FormAddDocument
            data={descriptionOptions}
            reload={call}
            field={field}
            onClose={() => {}}
            callDocument={callDocument}
          />
        )}
      </div>
      <br />
      {!loading ? (
        <Circle />
      ) : (
        <div className="w-full">
          <TableComplete
            header={[
              {
                name: "label",
                label: "Descripción",
              },
              {
                name: "description",
                label: "Número",
                type: "custom",
                builder: (value) => {
                  try {
                    const data = value ? JSON.parse(value) : {};
                    return data.numero || "-";
                  } catch {
                    return "-";
                  }
                },
              },
              {
                name: "description",
                label: "Cantidad",
                type: "custom",
                builder: (value) => {
                  try {
                    const data = value ? JSON.parse(value) : {};
                    return data.cantidad || "-";
                  } catch {
                    return "-";
                  }
                },
              },
              {
                name: "description",
                label: "Departamento",
                type: "custom",
                builder: (value) => {
                  try {
                    const data = value ? JSON.parse(value) : {};
                    const depts = [];
                    if (data.contabilidad === "si") depts.push("Contabilidad");
                    if (data.comercial === "si") depts.push("Comercial");
                    return depts.join(", ") || "-";
                  } catch {
                    return "-";
                  }
                },
              },
              {
                name: "description",
                label: "Estado de Documento",
                type: "custom",
                builder: (value) => {
                  try {
                    const data = value ? JSON.parse(value) : {};
                    const est = [];
                    if (data.org === "si") est.push("ORG");
                    if (data.leg === "si") est.push("LEG");
                    if (data.elecOrg === "si") est.push("ELEC. ORG.");
                    if (data.fotocopia === "si") est.push("FOTOCOPIA");
                    return est.join(", ") || "-";
                  } catch {
                    return "-";
                  }
                },
              },
              {
                name: "add",
                type: "action",
                label: "Opciones",
                sticky: true,
                actions: [
                  {
                    label: "Editar",
                    icon: "fas fa-edit",
                    action: handleForm,
                    color: "text-[#1d4ed8]",
                  },
                  {
                    label: "Eliminar",
                    icon: "fas fa-trash",
                    action: handleDelete,
                    color: "text-red-500",
                  },
                ],
              },
            ]}
            data={data}
          />
        </div>
      )}
    </div>
  );
};

const FormAddDocument = (props) => {
  const { data, item = null, reload, field, onClose, callDocument } = props;
  
  const parseExistingData = (item) => {
    if (!item?.description) {
      return {
        descripcion: validateArray(data) ? data[0].name : "",
        numero: "",
        cantidad: "",
        contabilidad: false,
        comercial: false,
        org: false,
        leg: false,
        elecOrg: false,
        fotocopia: false,
      };
    }
    
    try {
      const parsed = JSON.parse(item.description);
      return {
        descripcion: item.label || "",
        numero: parsed.numero || "",
        cantidad: parsed.cantidad || "",
        contabilidad: parsed.contabilidad === "si",
        comercial: parsed.comercial === "si",
        org: parsed.org === "si",
        leg: parsed.leg === "si",
        elecOrg: parsed.elecOrg === "si",
        fotocopia: parsed.fotocopia === "si",
      };
    } catch {
      return {
        descripcion: item.label || "",
        numero: "",
        cantidad: "",
        contabilidad: false,
        comercial: false,
        org: false,
        leg: false,
        elecOrg: false,
        fotocopia: false,
      };
    }
  };

  const [values, setValues] = useState(parseExistingData(item));
  const [isNew, setIsNew] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    if (isNew) {
      await handleCreateOption(values.descripcion);
    }

    // Crear objeto con estructura específica
    const descriptionObject = {
      descripcion: values.descripcion,
      numero: values.numero,
      cantidad: values.cantidad,
      contabilidad: values.contabilidad ? "si" : "",
      comercial: values.comercial ? "si" : "",
      org: values.org ? "si" : "",
      leg: values.leg ? "si" : "",
      elecOrg: values.elecOrg ? "si" : "",
      fotocopia: values.fotocopia ? "si" : "",
    };

    await requestAuth(
      item ? "put" : "post",
      item
        ? `/dataSet/procedure/subData/${item.id}`
        : `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
      {
        Label: values.descripcion,
        Description: JSON.stringify(descriptionObject),
      }
    )
      .then(() => {
        reload();
        onClose();
        if (!item) {
          setValues({
            descripcion: validateArray(data) ? data[0].name : "",
            numero: "",
            cantidad: "",
            contabilidad: false,
            comercial: false,
            org: false,
            leg: false,
            elecOrg: false,
            fotocopia: false,
          });
          setIsNew(false);
        }
        toast.success("Registro exitoso");
      })
      .catch((error) => {
        console.error("Error al guardar:", error);
        toast.error("Se produjo un error al guardar");
      });
  }

  async function handleCreateOption(value) {
    await requestAuth("post", "/Dropdown/Option", {
      Name: value,
      DropdownListLabel: field.urlInitial,
    }).then(() => {
      callDocument();
    });
  }

  function handleChangeInp(e) {
    const { name, value } = e.target;
    setValues((a) => ({
      ...a,
      [name]: value,
    }));
  }

  function handleChange(e) {
    setValues((a) => ({
      ...a,
      descripcion: e.value,
    }));
    setIsNew(e.__isNew__ || false);
  }

  function handleCheckbox(name) {
    setValues((a) => ({
      ...a,
      [name]: !a[name],
    }));
  }

  return (
    <form className="flex flex-col gap-3">
      <div>
        <Label className={`mt-2`}>Descripción</Label>
        {validateArray(data) ? (
          <CreatableSelect
            isSearchable={true}
            onChange={handleChange}
            value={{ value: values.descripcion, label: values.descripcion }}
            styles={{
              placeholder: (base) => ({
                ...base,
                color: "black",
              }),
            }}
            placeholder={"Seleccionar..."}
            isOptionSelected={false}
            options={data.map((option) => ({
              value: option.name,
              label: option.name,
            }))}
          />
        ) : null}
      </div>
      <div className="flex flex-row gap-2">
        <div className="flex-1">
          <Label className={`my-0`}>Número</Label>
          <input
            value={values.numero}
            onChange={handleChangeInp}
            className="w-full p-2 rounded-md"
            type="text"
            name="numero"
            placeholder="Ej: 2025-0026"
          />
        </div>

        <div className="flex-1">
          <Label className={`my-0`}>Cantidad</Label>
          <input
            value={values.cantidad}
            onChange={handleChangeInp}
            className="w-full p-2 rounded-md"
            type="number"
            name="cantidad"
            placeholder="Ej: 145"
          />
        </div>
      </div>

      <div>
        <Label className={`my-0`}>Departamento</Label>
        <div className="flex gap-4 p-2 bg-white rounded-md">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={values.contabilidad}
              onChange={() => handleCheckbox("contabilidad")}
              className="w-4 h-4"
            />
            <span>Contabilidad</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={values.comercial}
              onChange={() => handleCheckbox("comercial")}
              className="w-4 h-4"
            />
            <span>Comercial</span>
          </label>
        </div>
      </div>

      <div>
        <Label className={`my-0`}>Estado de Documento</Label>
        <div className="flex gap-4 p-2 bg-white rounded-md flex-wrap">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={values.org}
              onChange={() => handleCheckbox("org")}
              className="w-4 h-4"
            />
            <span>ORG</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={values.leg}
              onChange={() => handleCheckbox("leg")}
              className="w-4 h-4"
            />
            <span>LEG</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={values.elecOrg}
              onChange={() => handleCheckbox("elecOrg")}
              className="w-4 h-4"
            />
            <span>ELEC. ORG.</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={values.fotocopia}
              onChange={() => handleCheckbox("fotocopia")}
              className="w-4 h-4"
            />
            <span>FOTOCOPIA</span>
          </label>
        </div>
      </div>

      <Button onClick={handleSubmit} className={`px-3 py-3 mt-2`}>
        Guardar
      </Button>
    </form>
  );
};

export default InputSubDocumentToDeliver;